// Support.js
import React from 'react';
import './Support.css';
import supportHeaderImage from  '../../assets/images/purple-support-floatin-text.svg';
import comingSoonImage from '../../assets/images/purple-comingsoon-floatin-lefttoright-text.svg';

const Support = () => {
    return (
        <div className="support-section">
            <img src={supportHeaderImage} alt="Support" />
            <br />
            <img src={comingSoonImage} alt="Support" />
        </div>
    );
};

export default Support;